export default {"src":"/login-app/[GIT_HASH]/_next/static/media/git_merged.0614ec5d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};